import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage, isSupported } from "firebase/messaging";
import { NotificationManager } from 'react-notifications';
import { vapidKey, firebaseConfig } from '../config';

class FirebaseService {
    constructor() {
        try {
            this.firebaseApp = initializeApp(firebaseConfig);
            this.initMessaging();
        } catch (error) {
            console.warn("[Firebase] Init error:", error);
        }
    }

    async initMessaging() {
        try {
            // Kiểm tra xem trình duyệt có hỗ trợ Firebase Messaging không
            const supported = await isSupported();
            if (!supported) {
                console.warn("[Firebase] Messaging not supported on this browser.");
                return;
            }

            // Kiểm tra có hỗ trợ Notification API không
            if (typeof Notification === "undefined") {
                console.warn("[Firebase] Notification API not available.");
                return;
            }

            this.messaging = getMessaging(this.firebaseApp);
            this.setupTokenFetching();
        } catch (error) {
            console.warn("[Firebase] initMessaging exception:", error);
        }
    }

    setupTokenFetching() {
        this.fetchToken = async (setCurrentToken) => {
            try {
                // Nếu Notification không có, bỏ qua
                if (typeof Notification === "undefined") {
                    console.warn("[Firebase] Notification API not supported.");
                    return;
                }

                const permission = await Notification.requestPermission();
                if (permission === "granted") {
                    await this.getTokenForNotifications(setCurrentToken);
                } else if (permission === "denied") {
                    console.warn("[Firebase] User denied notification permission.");
                } else {
                    console.warn("[Firebase] Notification permission dismissed.");
                }
            } catch (error) {
                console.error("[Firebase] fetchToken error:", error);
            }
        };
    }

    async getTokenForNotifications(setCurrentToken) {
        try {
            if (!this.messaging) {
                console.warn("[Firebase] Messaging not initialized.");
                return;
            }

            const currentToken = await getToken(this.messaging, { vapidKey });
            if (currentToken) {
                setCurrentToken(currentToken);
                console.log("[Firebase] Token:", currentToken);
            } else {
                console.warn("[Firebase] No token retrieved.");
            }
        } catch (error) {
            console.error("[Firebase] getTokenForNotifications error:", error);
        }
    }

    onMessageListener(callback) {
        try {
            if (!this.messaging) {
                console.warn("[Firebase] Messaging not initialized, skip listener.");
                return;
            }

            onMessage(this.messaging, (payload) => {
                console.log("[Firebase] onMessage:", payload);

                if (payload?.notification) {
                    NotificationManager.warning(
                        payload.notification.body,
                        payload.notification.title,
                        10000
                    );
                }

                if (typeof callback === "function") {
                    callback(payload);
                }
            });
        } catch (error) {
            console.error("[Firebase] onMessageListener error:", error);
        }
    }
}

const firebaseService = new FirebaseService();
export default firebaseService;


// import { initializeApp } from "firebase/app";
// import { getMessaging, getToken, onMessage } from "firebase/messaging";
// import { NotificationManager } from 'react-notifications';
// import { vapidKey, firebaseConfig } from '../config';

// class FirebaseService {
//     constructor() {
//         this.firebaseApp = initializeApp(firebaseConfig);
//         this.messaging = getMessaging(this.firebaseApp);
//         this.setupTokenFetching();
//     }

//     setupTokenFetching() {
//         this.fetchToken = (setCurrentToken) => {
//             Notification.requestPermission().then((permission) => {
//                 if (permission === 'granted') {
//                     this.getTokenForNotifications(setCurrentToken);
//                 } else if (permission === 'denied') {
//                     // Xử lý khi quyền bị từ chối
//                 } else {
//                     // Xử lý khi quyền bị bỏ qua
//                 }
//             });
//         };
//     }

//     getTokenForNotifications(setCurrentToken) {
//         getToken(this.messaging, { vapidKey })
//             .then((currentToken) => {
//                 if (currentToken) {
//                     setCurrentToken(currentToken);
//                 } else {
//                     // Xử lý khi không có token
//                 }
//             })
//             .catch((err) => {
//                 // Xử lý khi có lỗi
//             });
//     }

//     onMessageListener(callback) {
//         onMessage(this.messaging, (payload) => {
//             console.log("onMessageListener: ", payload);
//             NotificationManager.warning(payload.notification.body, payload.notification.title, 15000);
//             // Gọi lại hàm callback nếu được xác định
//             if (typeof callback === 'function') {
//                 callback();
//             }
//         });
//     }
// }

// const firebaseService = new FirebaseService();
// export default firebaseService;
